import { Component, Input, OnChanges } from '@angular/core';

@Component({
  standalone: false,
  selector: 'ingsv-adm-properties-form-notification-message',
  templateUrl: './properties-form-notification-message.component.html',
  styleUrls: ['./properties-form-notification-message.component.scss']
})
export class PropertiesFormNotificationMessageComponent {
  @Input() inputData: any;
  @Input() value: any;

  constructor() { }
}
